<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="700"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="等级名称">
                <a-input placeholder="请输入等级名称" v-decorator.trim="['name', validatorRules.name]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序(小→高)">
                <a-input-number style="width: 100%" :min="1" placeholder="数字越小等级越低" v-decorator="['sort', validatorRules.sort]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="升级门槛">
                <a-input-number style="width: 100%" :min="0" :precision="2" placeholder="累计零售实付金额" v-decorator="['upgradeAmount', validatorRules.upgradeAmount]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="保级金额">
                <a-input-number style="width: 100%" :min="0" :precision="2" placeholder="滚动12个月内实付" v-decorator="['keepAmount']" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="折扣率">
                <a-input-number style="width: 100%" :min="1" :max="99" :precision="0" placeholder="如 98 表示98折" v-decorator="['discountRate']" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="积分倍率(P1生效)">
                <a-input-number style="width: 100%" :min="0.1" :precision="1" placeholder="默认 1.0" v-decorator="['pointMultiple']" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生日礼类型">
                <a-select placeholder="请选择（可不选）" allow-clear v-decorator="['birthdayType']">
                  <a-select-option value="points">积分</a-select-option>
                  <a-select-option value="coupon">优惠券</a-select-option>
                  <a-select-option value="discount">折扣</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生日礼范围">
                <a-select placeholder="请选择（可不选）" allow-clear v-decorator="['birthdayScope']">
                  <a-select-option value="day">生日当天</a-select-option>
                  <a-select-option value="month">生日当月</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { levelCreate, levelUpdate } from '@/api/plugin/member'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'LevelModal',
  mixins: [mixinDevice],
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        name: {
          rules: [
            { required: true, message: '请输入等级名称!' },
            { max: 50, message: '长度不能超过 50 个字符', trigger: 'blur' }
          ]
        },
        sort: {
          rules: [
            { required: true, message: '请输入排序!' }
          ]
        },
        upgradeAmount: {
          rules: [
            { required: true, message: '请输入升级门槛!' }
          ]
        }
      }
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,
          'name', 'sort', 'upgradeAmount', 'keepAmount', 'discountRate', 'pointMultiple', 'birthdayType', 'birthdayScope'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let obj
          if (!this.model.id) {
            obj = levelCreate(values)
          } else {
            obj = levelUpdate(this.model.id, Object.assign({}, this.model, values))
          }
          obj.then((res) => {
            if (res.code === 200) {
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style scoped>
</style>
